import type { SidebarTabItem } from '@/helpers/types/SidebarTabItem';
import type { IconColor } from '@therame/ui';
import { patientFileMarkItems } from './patientFileMarkItems';

const colorLevels: { textColor: IconColor; bgColor: string }[] = [
  { textColor: 'text-tm-gray-900', bgColor: 'bg-tm-gray-300' },
  { textColor: 'text-tm-gray-900', bgColor: 'bg-tm-gray-300' },
  { textColor: 'text-white', bgColor: 'bg-tm-gray-600' },
  { textColor: 'text-white', bgColor: 'bg-tm-gray-900' },
];

export const getPatientFileSidebarTabItems = (): SidebarTabItem[] => {
  return patientFileMarkItems
    .filter((item) => !item.isDisabledByFeatureToggle)
    .map((item, index) => ({
      title: item.title,
      view: item.mark,
      icon: item.icon,
      textColor: colorLevels[index]?.textColor ?? 'text-tm-gray-900',
      bgColor: colorLevels[index]?.bgColor ?? 'bg-tm-gray-300',
    }));
};
